import { ErrorHandler, Injectable } from '@angular/core';
import { ErrorTracking } from './error-tracking.service';

@Injectable()
export class CustomErrorHandler extends ErrorHandler {
  constructor(private errorTracking: ErrorTracking) {
    super();
  }

  handleError(error: Error): void {
    this.errorTracking.captureException(error);
    super.handleError(error);
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/sq/webapp/src/app/@shared/tracking/custom-error-handler.service.ts